module.exports = __webpack_public_path__ + "static/media/storage-boxes.4259d83c.jpg";